import type { TFunction } from 'i18next';
import { logisticsErrorReason } from '@d-orca/shared/client/logistics';
import type { IToast } from '@components/ui/Toasts/useToasts';

/**
 * A failed logistics write's toast: the action-specific title, and under it
 * WHY the server refused it (the shared reason helper). The server's own
 * English message never reaches the toast — an unexplained failure reads as
 * the generic "try again" line.
 */
export function failureToast(t: TFunction, error: unknown, title: string): Omit<IToast, 'id'> {
  const { key, values } = logisticsErrorReason(error);
  return { kind: 'error', title, sub: t(key, values) };
}
